// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.nav-btn-loading[data-v-ea126920] {\n  background-color: var(--sea) !important;\n  color: white !important;\n}\n.btn-primary[data-v-ea126920] {\n  font-size: 1rem !important;\n  font-weight: 400;\n}\n.btn-nav[data-v-ea126920] {\n  box-shadow: 0px 4px 40px rgba(155, 157, 157, 0.2) !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
